var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Link, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RumEntityLabel } from '../../../observability/rumEntity';
import { ROUTER_URL } from '../../../router/constants';
import { ConfirmDialog } from '../confirmDialog';
var StyledBar = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        background: theme.palette.primary.light,
        padding: theme.spacing(3, 6),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(2),
    });
});
var StyledTitle = styled(Typography)({
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
export var ExitBar = function (_a) {
    var title = _a.title, titleEntity = _a.titleEntity, isDirty = _a.isDirty, onSave = _a.onSave, _b = _a.exitTo, exitTo = _b === void 0 ? ROUTER_URL.Home : _b, bypassConfirm = _a.bypassConfirm;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var t = useTranslation().t;
    var navigate = useNavigate();
    var handleConfirm = function () {
        setOpen(false);
        onSave === null || onSave === void 0 ? void 0 : onSave();
    };
    var handleExit = function () {
        setOpen(false);
        navigate(exitTo);
    };
    var handleExitClick = function () {
        if (bypassConfirm) {
            navigate(exitTo);
        }
        else {
            setOpen(true);
        }
    };
    return (_jsxs(StyledBar, { children: [_jsx(StyledTitle, __assign({ variant: "h3", title: title }, { children: titleEntity ? (_jsx(RumEntityLabel, __assign({ kind: titleEntity.kind, id: titleEntity.id }, { children: title }))) : (title) })), _jsx(Link, __assign({ component: "button", onClick: handleExitClick, sx: { flexShrink: 0 } }, { children: t('action.exit') })), isDirty ? (_jsx(ConfirmDialog, { open: open, onClose: function () { return setOpen(false); }, title: t('confirmation.unsavedChange'), message: t('confirmation.confirmExit'), confirmButtonText: "saveContinue", skipSaveButtonText: "skipSave", onConfirm: handleConfirm, onSkipSaveConfirm: handleExit })) : (_jsx(ConfirmDialog, { open: open, onClose: function () { return setOpen(false); }, title: t('confirmation.title'), message: t('confirmation.continueExit'), confirmButtonText: "continue", onConfirm: handleExit }))] }));
};
